const updateGenres = (state, { payload: { genres } }) => {
	state.genres = genres;
};

export default updateGenres;
